import styles from "./modal.module.scss";
import { Box, Modal } from "@mui/material";
import PropTypes from "prop-types";
import classnames from "classnames";

export default function KeepMountedModal({
  children,
  className,
  open,
  onClose,
  ...rest
}) {
  return (
    <Modal className={styles.root} open={open} onClose={onClose}>
      <Box className={classnames(styles.container, className)} {...rest}>
        {children}
      </Box>
    </Modal>
  );
}

KeepMountedModal.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export { KeepMountedModal as Modal };
